import React from "react";

export default function SQLServer_YEAR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_YEAR</h1>
      <p>This is the SQLServer_YEAR component generated from the SQL JSON.</p>
    </div>
  );
}
